import * as React from 'react';
import { SessionTimer } from './SessionTimer';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { doGet } from 'sos-eservice-common/js/services';

interface ISessionDialogTranslation {
  sessionDialogText: string;
  sessionDialogHeader: string;
  sessionIngoreButtonText: string;
  sessionRenewButtonText: string;
}

interface ISessionWarningDialogProps {
  isOpen: boolean;
  onClose: () => void;
  renewSessionUrl: string;
  translation: ISessionDialogTranslation;
  sessionExpirationTime?: Date;
}

export class SessionWarningDialog extends React.Component<ISessionWarningDialogProps> {
  doAction = (url: string) => {
    doGet(url).then((response) => {
      if (response instanceof ResponseError) {
        console.error('Error when renewing session: ', response);
      } else {
        this.props.onClose();
      }
    });
  };

  render(): JSX.Element {
    if (!this.props.sessionExpirationTime && this.props.isOpen) return <></>;
    return (
      <>
        <Dialog isOpen={this.props.isOpen} onRequestClose={this.props.onClose} shouldCloseOnOverlayClick={false}>
          <button type="button" className="close" onClick={this.props.onClose}>
            <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
          </button>
          <React.Fragment>
            <div className="header">
              <h2>{this.props.translation.sessionDialogHeader}</h2>
            </div>
            <p>{this.props.translation.sessionDialogText}</p>
            {this.props.sessionExpirationTime && <SessionTimer timeoutDate={this.props.sessionExpirationTime} />}
            <div className="footer">
              {this.props.translation.sessionIngoreButtonText &&
              this.props.translation.sessionIngoreButtonText != '' ? (
                <button
                  type="button"
                  key={this.props.translation.sessionIngoreButtonText + Date.now().toString()}
                  onClick={(_) => this.props.onClose()}
                  className={'button button--white'}>
                  {this.props.translation.sessionIngoreButtonText}
                </button>
              ) : (
                <></>
              )}
              <button
                type="button"
                key={this.props.translation.sessionRenewButtonText + Date.now().toString()}
                onClick={(_) => this.doAction(this.props.renewSessionUrl)}
                className={'button'}>
                {this.props.translation.sessionRenewButtonText}
              </button>
            </div>
          </React.Fragment>
        </Dialog>
      </>
    );
  }
}
